var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "editModal",
          attrs: {
            size: "lg",
            title: "Aktualisierung der Kontaktdaten",
            "ok-title": _vm.renew
              ? "Verlängerte Lizenz erstellen"
              : "Daten Aktualisieren",
            "cancel-title": "Abbrechen",
            lazy: "",
          },
          on: { ok: _vm.submit },
        },
        [
          _vm.renew
            ? _c("p", [
                _vm._v(
                  "Bitte Prüfen Sie Ihre Kontaktdaten, bevor Ihnen eine neue Lizenz zugesendet wird."
                ),
              ])
            : _c("p", [_vm._v("Bitte geben Sie die aktualisierten Daten ein")]),
          _vm._v(" "),
          _c("div", [_c("strong", [_vm._v(" Fachlicher Kontakt ")])]),
          _vm._v(" "),
          _c("edit-contact", {
            attrs: { contact: _vm.contact },
            on: {
              "update:contact": function ($event) {
                _vm.contact = $event
              },
            },
          }),
          _vm._v(" "),
          _c("div", [_c("strong", [_vm._v(" Kontakt der IT-Abteilung ")])]),
          _vm._v(" "),
          _c("edit-contact", {
            attrs: { contact: _vm.itContact },
            on: {
              "update:contact": function ($event) {
                _vm.itContact = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "updatingModal",
          attrs: {
            title: "Daten werden aktualisiert",
            "hide-footer": "",
            lazy: "",
            "no-fade": "",
          },
        },
        [
          _c("p", [
            _c("span", { staticClass: "fa fa-spin fa-spinner" }),
            _vm._v("\n            Bitte warten\n        "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "doneModal",
          attrs: {
            title: "Daten aktualisiert",
            "ok-only": "",
            "ok-title": "Schließen",
            lazy: "",
            "no-fade": "",
          },
        },
        [
          _vm.renew
            ? _c("p", [
                _vm._v(
                  "\n            Ihre Daten wurden aktualisiert und die Lizenz wurde Verlängert.\n        "
                ),
              ])
            : _c("p", [
                _vm._v(
                  "\n            Ihre Daten wurden aktualisiert\n        "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "errorModal",
          attrs: {
            title: "Es trat ein Fehler auf",
            "ok-only": "",
            "ok-title": "Schließen",
            lazy: "",
            "no-fade": "",
          },
        },
        [
          _c("p", [_vm._v("Ihre Daten konnten nicht aktualisiert werden.")]),
          _vm._v(" "),
          _c("p", [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }